// Pinterest Post (đăng & quản lý Pin) i18n fragment — song ngữ, parity vi↔en.
const fragment = {
  vi: {
    'pinterestPost.common.cancel': 'Huỷ',

    // status
    'pinterestPost.status.all': 'Tất cả trạng thái',
    'pinterestPost.status.allShort': 'Tất cả',
    'pinterestPost.status.draft': 'Nháp',
    'pinterestPost.status.scheduled': 'Đã lên lịch',
    'pinterestPost.status.published': 'Đã đăng',
    'pinterestPost.status.failed': 'Lỗi',

    // list
    'pinterestPost.list.title': 'Bài viết Pinterest',
    'pinterestPost.list.create': 'Tạo Pin',
    'pinterestPost.list.searchLabel': 'Tìm kiếm',
    'pinterestPost.list.searchPlaceholder': 'Tìm theo tiêu đề / mô tả',
    'pinterestPost.list.accountLabel': 'Tài khoản',
    'pinterestPost.list.allAccounts': 'Tất cả tài khoản',
    'pinterestPost.list.statusLabel': 'Trạng thái',
    'pinterestPost.list.apply': 'Lọc',
    'pinterestPost.list.reset': 'Đặt lại',

    // table
    'pinterestPost.table.col.account': 'Tài khoản',
    'pinterestPost.table.col.media': 'Ảnh',
    'pinterestPost.table.col.content': 'Nội dung',
    'pinterestPost.table.col.board': 'Board',
    'pinterestPost.table.col.status': 'Trạng thái',
    'pinterestPost.table.col.time': 'Thời gian',
    'pinterestPost.table.col.link': 'Link Pin',
    'pinterestPost.table.col.createdAt': 'Tạo lúc',
    'pinterestPost.table.col.actions': 'Thao tác',
    'pinterestPost.table.badge.published': 'Đã đăng',
    'pinterestPost.table.badge.failed': 'Lỗi',
    'pinterestPost.table.badge.scheduled': '📅 Đã lên lịch',
    'pinterestPost.table.badge.processing': '⏳ Đang đăng',
    'pinterestPost.table.badge.draft': 'Nháp',
    'pinterestPost.table.media.carousel': '🖼 Carousel · {count}',
    'pinterestPost.table.media.image': '🖼 Ảnh',
    'pinterestPost.table.time.waitingCron': 'Đang chờ hệ thống đăng',
    'pinterestPost.table.time.processing': 'Đang đăng…',
    'pinterestPost.table.copyLink': 'Sao chép link',
    'pinterestPost.table.validate.pickTime': 'Vui lòng chọn thời gian.',
    'pinterestPost.table.validate.tooSoon': 'Thời gian đăng phải cách hiện tại ít nhất {min} phút.',
    'pinterestPost.table.tooltip.open': 'Xem trên Pinterest',
    'pinterestPost.table.tooltip.reschedule': 'Đổi giờ đăng',
    'pinterestPost.table.tooltip.cancelSchedule': 'Huỷ lịch đăng',
    'pinterestPost.table.tooltip.publishNow': 'Đăng ngay',
    'pinterestPost.table.tooltip.edit': 'Sửa Pin',
    'pinterestPost.table.tooltip.delete': 'Xoá Pin',
    'pinterestPost.table.reschedule.title': 'Đổi giờ đăng',
    'pinterestPost.table.reschedule.placeholder': 'Chọn ngày giờ mới',
    'pinterestPost.table.reschedule.minLead': 'Cách hiện tại tối thiểu {min} phút.',
    'pinterestPost.table.reschedule.save': 'Lưu lịch',
    'pinterestPost.table.confirm.delete.title': 'Xoá Pin?',
    'pinterestPost.table.confirm.delete.desc':
      'Pin sẽ bị xoá khỏi hệ thống. Pin đã đăng trên Pinterest vẫn còn.',
    'pinterestPost.table.confirm.delete.confirm': 'Xoá',
    'pinterestPost.table.confirm.publish.title': 'Đăng ngay Pin đã lên lịch?',
    'pinterestPost.table.confirm.publish.desc':
      'Lịch đăng tự động sẽ bị huỷ và Pin sẽ được đăng ngay lập tức.',
    'pinterestPost.table.confirm.publish.confirm': 'Đăng ngay',
    'pinterestPost.table.confirm.cancel.title': 'Huỷ lịch đăng?',
    'pinterestPost.table.confirm.cancel.desc': 'Pin sẽ chuyển về trạng thái Nháp.',
    'pinterestPost.table.confirm.cancel.confirm': 'Huỷ lịch',
    'pinterestPost.table.toast.deleted': 'Đã xoá Pin.',
    'pinterestPost.table.toast.published': 'Đăng Pin thành công.',
    'pinterestPost.table.toast.rescheduled': 'Đã cập nhật lịch đăng.',
    'pinterestPost.table.toast.cancelled': 'Đã huỷ lịch đăng.',
    'pinterestPost.table.empty.title': 'Chưa có Pin nào',
    'pinterestPost.table.empty.desc': 'Tạo Pin đầu tiên để đăng lên Pinterest.',

    // form
    'pinterestPost.form.title.create': 'Tạo Pin Pinterest',
    'pinterestPost.form.title.edit': 'Sửa Pin Pinterest',
    'pinterestPost.form.section.account': 'Tài khoản & bảng',
    'pinterestPost.form.section.accountHint': 'Chọn tài khoản Pinterest và bảng (board) để lưu Pin',
    'pinterestPost.form.section.media': 'Hình ảnh',
    'pinterestPost.form.section.mediaHint': 'Tải lên 1–5 ảnh. 1 ảnh tạo Pin thường, từ 2 ảnh tự động thành carousel.',
    'pinterestPost.form.section.content': 'Nội dung',
    'pinterestPost.form.section.contentHint': 'Tiêu đề, mô tả và link đích (tuỳ chọn)',
    'pinterestPost.form.section.modeHint': 'Lưu nháp, lên lịch tự động hoặc đăng ngay',
    'pinterestPost.form.required': 'bắt buộc',
    'pinterestPost.form.tip.account': 'Tài khoản Pinterest đã kết nối sẽ đứng tên đăng Pin này.',
    'pinterestPost.form.tip.board': 'Bảng (board) nơi Pin được lưu trên Pinterest. Mỗi Pin phải thuộc một board.',
    'pinterestPost.form.tip.title': 'Tiêu đề hiển thị trên Pin (tối đa 100 ký tự). Nên ngắn gọn, hấp dẫn.',
    'pinterestPost.form.tip.description': 'Mô tả chi tiết cho Pin (tối đa 800 ký tự). Giúp người xem và tìm kiếm hiểu nội dung.',
    'pinterestPost.form.tip.link': 'Trang web sẽ mở khi người dùng bấm vào Pin (vd: trang sản phẩm, bài viết).',
    'pinterestPost.form.tip.alt': 'Mô tả nội dung ảnh cho người khiếm thị và SEO. Chỉ áp dụng cho Pin một ảnh.',
    'pinterestPost.form.timezoneNote': 'Múi giờ:',
    'pinterestPost.form.willPostAt': 'Sẽ đăng lúc',
    'pinterestPost.form.footerDraft': 'Nháp có thể chỉnh sửa, lên lịch hoặc đăng bất cứ lúc nào.',
    'pinterestPost.form.footerSchedule': 'Pin sẽ được hệ thống tự động đăng đúng thời điểm bạn chọn.',
    'pinterestPost.form.footerPublish': 'Pin sẽ được đăng lên Pinterest ngay khi bạn nhấn nút.',
    'pinterestPost.form.preview.label': 'Xem trước',
    'pinterestPost.form.preview.empty': 'Ảnh Pin sẽ hiển thị ở đây',
    'pinterestPost.form.preview.titlePlaceholder': 'Tiêu đề Pin của bạn',
    'pinterestPost.form.preview.descPlaceholder': 'Mô tả Pin sẽ hiển thị ở đây…',
    'pinterestPost.form.preview.imageCount': '{n} ảnh',
    'pinterestPost.form.preview.noAccount': 'Chưa chọn tài khoản',
    'pinterestPost.form.mediaTypeLabel': 'Loại media',
    'pinterestPost.form.typeImage': 'Ảnh đơn',
    'pinterestPost.form.typeCarousel': 'Carousel',
    'pinterestPost.form.imageHint': '1 ảnh cho mỗi Pin.',
    'pinterestPost.form.carouselHint': 'Từ 2 đến {max} ảnh.',
    'pinterestPost.form.addImage': 'Thêm ảnh',
    'pinterestPost.form.removeImage': 'Xoá ảnh',
    'pinterestPost.form.account': 'Tài khoản Pinterest',
    'pinterestPost.form.accountPlaceholder': 'Chọn tài khoản',
    'pinterestPost.form.board': 'Board',
    'pinterestPost.form.boardPlaceholder': 'Chọn board',
    'pinterestPost.form.selectAccountFirst': 'Chọn tài khoản trước',
    'pinterestPost.form.titleLabel': 'Tiêu đề',
    'pinterestPost.form.titlePlaceholder': 'Tiêu đề Pin (tối đa 100 ký tự)',
    'pinterestPost.form.descLabel': 'Mô tả',
    'pinterestPost.form.descPlaceholder': 'Mô tả Pin (tối đa 800 ký tự)',
    'pinterestPost.form.linkLabel': 'Đường dẫn',
    'pinterestPost.form.linkPlaceholder': 'https://trang-dich-cua-ban.com',
    'pinterestPost.form.linkHint': 'Link mở ra khi người dùng bấm vào Pin (vd: trang sản phẩm).',
    'pinterestPost.form.altLabel': 'Mô tả ảnh (alt text)',
    'pinterestPost.form.altPlaceholder': 'Mô tả ngắn nội dung ảnh',
    'pinterestPost.form.altHint': 'Giúp người khiếm thị và công cụ tìm kiếm hiểu nội dung ảnh.',
    'pinterestPost.form.modeLabel': 'Chế độ đăng',
    'pinterestPost.form.mode.draft': 'Lưu nháp',
    'pinterestPost.form.mode.draftHint': 'Lưu để chỉnh sửa và đăng sau.',
    'pinterestPost.form.mode.schedule': 'Lên lịch',
    'pinterestPost.form.mode.scheduleHint': 'Tự động đăng vào thời điểm chỉ định.',
    'pinterestPost.form.mode.publish': 'Đăng ngay',
    'pinterestPost.form.mode.publishHint': 'Gửi Pin lên Pinterest ngay lập tức.',
    'pinterestPost.form.scheduleTime': 'Thời gian đăng',
    'pinterestPost.form.schedulePlaceholder': 'Chọn ngày và giờ đăng',
    'pinterestPost.form.scheduleHint': 'Tối thiểu cách hiện tại {min} phút.',
    'pinterestPost.form.cancel': 'Huỷ',
    'pinterestPost.form.submitDraft': 'Lưu nháp',
    'pinterestPost.form.submitSchedule': '📅 Lên lịch đăng',
    'pinterestPost.form.submitPublish': '🚀 Đăng ngay',
    'pinterestPost.form.toast.selectAccount': 'Vui lòng chọn tài khoản Pinterest.',
    'pinterestPost.form.toast.selectBoard': 'Vui lòng chọn board.',
    'pinterestPost.form.toast.mediaRequired': 'Cần ít nhất 1 ảnh.',
    'pinterestPost.form.toast.imageMax': 'Ảnh đơn chỉ nhận 1 ảnh.',
    'pinterestPost.form.toast.carouselMax': 'Carousel tối đa {max} ảnh.',
    'pinterestPost.form.toast.carouselMin': 'Carousel cần ít nhất 2 ảnh.',
    'pinterestPost.form.toast.pickTime': 'Vui lòng chọn thời gian đăng.',
    'pinterestPost.form.toast.tooSoon': 'Thời gian đăng phải cách hiện tại ít nhất {min} phút.',
    'pinterestPost.form.toast.saved': 'Đã lưu thành công.',
  },
  en: {
    'pinterestPost.common.cancel': 'Cancel',

    // status
    'pinterestPost.status.all': 'All statuses',
    'pinterestPost.status.allShort': 'All',
    'pinterestPost.status.draft': 'Draft',
    'pinterestPost.status.scheduled': 'Scheduled',
    'pinterestPost.status.published': 'Published',
    'pinterestPost.status.failed': 'Failed',

    // list
    'pinterestPost.list.title': 'Pinterest posts',
    'pinterestPost.list.create': 'Create Pin',
    'pinterestPost.list.searchLabel': 'Search',
    'pinterestPost.list.searchPlaceholder': 'Search by title / description',
    'pinterestPost.list.accountLabel': 'Account',
    'pinterestPost.list.allAccounts': 'All accounts',
    'pinterestPost.list.statusLabel': 'Status',
    'pinterestPost.list.apply': 'Filter',
    'pinterestPost.list.reset': 'Reset',

    // table
    'pinterestPost.table.col.account': 'Account',
    'pinterestPost.table.col.media': 'Image',
    'pinterestPost.table.col.content': 'Content',
    'pinterestPost.table.col.board': 'Board',
    'pinterestPost.table.col.status': 'Status',
    'pinterestPost.table.col.time': 'Time',
    'pinterestPost.table.col.link': 'Pin link',
    'pinterestPost.table.col.createdAt': 'Created at',
    'pinterestPost.table.col.actions': 'Actions',
    'pinterestPost.table.badge.published': 'Published',
    'pinterestPost.table.badge.failed': 'Failed',
    'pinterestPost.table.badge.scheduled': '📅 Scheduled',
    'pinterestPost.table.badge.processing': '⏳ Publishing',
    'pinterestPost.table.badge.draft': 'Draft',
    'pinterestPost.table.media.carousel': '🖼 Carousel · {count}',
    'pinterestPost.table.media.image': '🖼 Image',
    'pinterestPost.table.time.waitingCron': 'Waiting for the scheduler',
    'pinterestPost.table.time.processing': 'Publishing…',
    'pinterestPost.table.copyLink': 'Copy link',
    'pinterestPost.table.validate.pickTime': 'Please pick a time.',
    'pinterestPost.table.validate.tooSoon': 'Publish time must be at least {min} minutes from now.',
    'pinterestPost.table.tooltip.open': 'View on Pinterest',
    'pinterestPost.table.tooltip.reschedule': 'Change publish time',
    'pinterestPost.table.tooltip.cancelSchedule': 'Cancel schedule',
    'pinterestPost.table.tooltip.publishNow': 'Publish now',
    'pinterestPost.table.tooltip.edit': 'Edit Pin',
    'pinterestPost.table.tooltip.delete': 'Delete Pin',
    'pinterestPost.table.reschedule.title': 'Change publish time',
    'pinterestPost.table.reschedule.placeholder': 'Pick a new date & time',
    'pinterestPost.table.reschedule.minLead': 'At least {min} minutes from now.',
    'pinterestPost.table.reschedule.save': 'Save schedule',
    'pinterestPost.table.confirm.delete.title': 'Delete Pin?',
    'pinterestPost.table.confirm.delete.desc':
      'The Pin will be removed from the system. A published Pin stays on Pinterest.',
    'pinterestPost.table.confirm.delete.confirm': 'Delete',
    'pinterestPost.table.confirm.publish.title': 'Publish the scheduled Pin now?',
    'pinterestPost.table.confirm.publish.desc':
      'The auto-schedule will be cancelled and the Pin published immediately.',
    'pinterestPost.table.confirm.publish.confirm': 'Publish now',
    'pinterestPost.table.confirm.cancel.title': 'Cancel schedule?',
    'pinterestPost.table.confirm.cancel.desc': 'The Pin will revert to Draft.',
    'pinterestPost.table.confirm.cancel.confirm': 'Cancel schedule',
    'pinterestPost.table.toast.deleted': 'Pin deleted.',
    'pinterestPost.table.toast.published': 'Pin published.',
    'pinterestPost.table.toast.rescheduled': 'Schedule updated.',
    'pinterestPost.table.toast.cancelled': 'Schedule cancelled.',
    'pinterestPost.table.empty.title': 'No Pins yet',
    'pinterestPost.table.empty.desc': 'Create your first Pin to publish to Pinterest.',

    // form
    'pinterestPost.form.title.create': 'Create Pinterest Pin',
    'pinterestPost.form.title.edit': 'Edit Pinterest Pin',
    'pinterestPost.form.section.account': 'Account & board',
    'pinterestPost.form.section.accountHint': 'Choose the Pinterest account and the board to save the Pin to',
    'pinterestPost.form.section.media': 'Images',
    'pinterestPost.form.section.mediaHint': 'Upload 1–5 images. 1 image creates a standard Pin; 2+ become a carousel automatically.',
    'pinterestPost.form.section.content': 'Content',
    'pinterestPost.form.section.contentHint': 'Title, description and destination link (optional)',
    'pinterestPost.form.section.modeHint': 'Save a draft, schedule, or publish now',
    'pinterestPost.form.required': 'required',
    'pinterestPost.form.tip.account': 'The connected Pinterest account this Pin will be published under.',
    'pinterestPost.form.tip.board': 'The board where the Pin is saved on Pinterest. Every Pin must belong to a board.',
    'pinterestPost.form.tip.title': 'Title shown on the Pin (max 100 characters). Keep it short and catchy.',
    'pinterestPost.form.tip.description': 'Detailed description for the Pin (max 800 characters). Helps viewers and search understand it.',
    'pinterestPost.form.tip.link': 'The page opened when someone clicks the Pin (e.g. a product page or article).',
    'pinterestPost.form.tip.alt': 'Describes the image for visually impaired users and SEO. Single-image Pins only.',
    'pinterestPost.form.timezoneNote': 'Timezone:',
    'pinterestPost.form.willPostAt': 'Will publish at',
    'pinterestPost.form.footerDraft': 'A draft can be edited, scheduled or published anytime.',
    'pinterestPost.form.footerSchedule': 'The Pin will be auto-published at the time you choose.',
    'pinterestPost.form.footerPublish': 'The Pin will be published to Pinterest as soon as you click.',
    'pinterestPost.form.preview.label': 'Preview',
    'pinterestPost.form.preview.empty': 'Your Pin image will appear here',
    'pinterestPost.form.preview.titlePlaceholder': 'Your Pin title',
    'pinterestPost.form.preview.descPlaceholder': 'Your Pin description will appear here…',
    'pinterestPost.form.preview.imageCount': '{n} images',
    'pinterestPost.form.preview.noAccount': 'No account selected',
    'pinterestPost.form.mediaTypeLabel': 'Media type',
    'pinterestPost.form.typeImage': 'Single image',
    'pinterestPost.form.typeCarousel': 'Carousel',
    'pinterestPost.form.imageHint': '1 image per Pin.',
    'pinterestPost.form.carouselHint': '2 to {max} images.',
    'pinterestPost.form.addImage': 'Add image',
    'pinterestPost.form.removeImage': 'Remove image',
    'pinterestPost.form.account': 'Pinterest account',
    'pinterestPost.form.accountPlaceholder': 'Select account',
    'pinterestPost.form.board': 'Board',
    'pinterestPost.form.boardPlaceholder': 'Select board',
    'pinterestPost.form.selectAccountFirst': 'Select an account first',
    'pinterestPost.form.titleLabel': 'Title',
    'pinterestPost.form.titlePlaceholder': 'Pin title (max 100 characters)',
    'pinterestPost.form.descLabel': 'Description',
    'pinterestPost.form.descPlaceholder': 'Pin description (max 800 characters)',
    'pinterestPost.form.linkLabel': 'Link',
    'pinterestPost.form.linkPlaceholder': 'https://your-destination.com',
    'pinterestPost.form.linkHint': 'The link opened when someone clicks the Pin (e.g. a product page).',
    'pinterestPost.form.altLabel': 'Alt text',
    'pinterestPost.form.altPlaceholder': 'Short description of the image',
    'pinterestPost.form.altHint': 'Helps visually impaired users and search engines understand the image.',
    'pinterestPost.form.modeLabel': 'Publish mode',
    'pinterestPost.form.mode.draft': 'Save draft',
    'pinterestPost.form.mode.draftHint': 'Save to edit and publish later.',
    'pinterestPost.form.mode.schedule': 'Schedule',
    'pinterestPost.form.mode.scheduleHint': 'Auto-publish at the chosen time.',
    'pinterestPost.form.mode.publish': 'Publish now',
    'pinterestPost.form.mode.publishHint': 'Send the Pin to Pinterest immediately.',
    'pinterestPost.form.scheduleTime': 'Publish time',
    'pinterestPost.form.schedulePlaceholder': 'Pick a date and time',
    'pinterestPost.form.scheduleHint': 'At least {min} minutes from now.',
    'pinterestPost.form.cancel': 'Cancel',
    'pinterestPost.form.submitDraft': 'Save draft',
    'pinterestPost.form.submitSchedule': '📅 Schedule',
    'pinterestPost.form.submitPublish': '🚀 Publish now',
    'pinterestPost.form.toast.selectAccount': 'Please select a Pinterest account.',
    'pinterestPost.form.toast.selectBoard': 'Please select a board.',
    'pinterestPost.form.toast.mediaRequired': 'At least 1 image is required.',
    'pinterestPost.form.toast.imageMax': 'Single image accepts only 1 image.',
    'pinterestPost.form.toast.carouselMax': 'Carousel allows up to {max} images.',
    'pinterestPost.form.toast.carouselMin': 'Carousel needs at least 2 images.',
    'pinterestPost.form.toast.pickTime': 'Please pick a publish time.',
    'pinterestPost.form.toast.tooSoon': 'Publish time must be at least {min} minutes from now.',
    'pinterestPost.form.toast.saved': 'Saved successfully.',
  },
};

export default fragment;
